export enum StatusCode {
  AUTHORIZATION_FAILED = 1,
  FORBIDDEN = 2,
  INTERNAL_SERVER_ERROR = 3,
  RESTRICTED = 4,
}
